import { useTranslation } from 'react-i18next';

import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Link, Logo } from 'Components';
import { connectToTrainerDesktop, useSelectTestCourse } from 'Courses/data';
import { urls } from 'Router';
import { useAppDispatch } from 'Store';
import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  minWidth: 320,
  maxWidth: 400,
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`
}));

const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: Spacing.small,
  marginBottom: Spacing.medium
});

const Content = styled(Typography)({
  fontSize: '14px',
  lineHeight: '1.4',
  color: Colors.textColor,
  marginBottom: Spacing.medium
});

const Actions = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.small
});

export const MiniStartBanner = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const testCourse = useSelectTestCourse();

  const handleTestClick = () => {
    if (testCourse?.id) {
      dispatch(connectToTrainerDesktop(testCourse.id));
    }
  };

  return (
    <Container>
      <Header>
        <Typography variant="body2">{t('startBanner.welcomeIn')}</Typography>
        <Logo variant="menu" />
      </Header>

      <Content>{t('startBanner.welcomeMessage')}</Content>

      <Actions>
        <Button variant="contained" size="small" onClick={handleTestClick} disabled={!testCourse}>
          {t('startBanner.test')}
        </Button>

        <Link to={urls.treneoSite} label={t('startBanner.whatIsTreneo')} />
      </Actions>
    </Container>
  );
};
